import { ReactComponent as ArrowDownIcon } from "@icons/arrow-down.svg";
import { useTranslation } from "react-i18next";

export enum RefreshIndicatorType {
  Pull,
  Release
}

export const RefreshIndicator = ({ type }: { type: RefreshIndicatorType }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "refreshIndicator" });
  const config = {
    [RefreshIndicatorType.Pull]: {
      message: t("pullDownToRefresh"),
      iconClass: "h-4 w-4 text-navy-blue",
    },
    [RefreshIndicatorType.Release]: {
      message: t("releaseToRefresh"),
      iconClass: "h-4 w-4 text-navy-blue rotate-180",
    },
  }[type];

  return (
    <div className="h-[60px] select-none flex justify-center items-center">
      <div className="text-center flex gap-2 items-center font-bold">
        <ArrowDownIcon className={config.iconClass} />
        {config.message}
      </div>
    </div>
  );
};
